<template>
  <div>
    <div v-if="isFormVisible">
      <h2 class="h1 text-primary mb-20">Попробовать бесплатно 14 дней</h2>
      <div class="mb-48">
        <span class="text-muted">У вас уже есть аккаунт? </span>
        <router-link :to="{ name: 'login' }" class="link">Войти</router-link>
      </div>
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        @submit.native.prevent="onRegister">
        <el-form-item label="Имя" prop="name" class="mb-32">
          <el-input v-model="form.name" type="text" />
        </el-form-item>
        <el-form-item label="E-mail" prop="email" class="mb-32">
          <el-input v-model="form.email" type="email" autocomplete="new-password" />
        </el-form-item>
        <el-form-item label="Придумайте пароль" prop="password" class="mb-32">
          <el-input
            v-model="form.password"
            type="password"
            autocomplete="new-password"
            show-password />
        </el-form-item>
        <el-form-item>
          <el-button
            :loading="$mip('register')"
            type="primary"
            native-type="submit">
            Зарегистрироваться
          </el-button>
        </el-form-item>
      </el-form>
      <div class="mt-32 text-muted">
        Нажимая на кнопку «Зарегистрироваться» вы даете согласие на
        <a class="link" @click.prevent="agreementDialogVisible = true">обработку персональных данных</a>
      </div>
    </div>

    <div v-else>
      <p class="mb-20">Пожалуйста, активируйте личный кабинет по ссылке в письме.</p>
      <router-link :to="{ name: 'login' }" class="link">Войти</router-link>
    </div>

    <el-dialog
      title="Соглашение"
      :visible.sync="agreementDialogVisible"
      custom-class="el-dialog--medium"
      @close="agreementDialogVisible = false">
      <p class="mb-24">Lorem ipsum dolor sit amet consectetur adipisicing elit. Ratione nemo similique, labore vero fugit molestiae itaque voluptatem nihil odit quod atque harum commodi perferendis? Excepturi a amet eius nisi, ratione labore autem eum aliquam, praesentium nobis, molestiae inventore mollitia incidunt.</p>
      <p class="mb-24">Lorem ipsum dolor sit amet consectetur, adipisicing elit. Corporis libero perspiciatis quod praesentium quos dolorem a, ad commodi sapiente eius maiores accusamus voluptate expedita id. Amet quis velit consequatur iste, laudantium vitae quam repellat saepe, corrupti, dicta aspernatur nostrum corporis expedita provident quos possimus. Magni, nihil asperiores? Reiciendis, dolore natus.</p>
      <p class="mb-24">Lorem ipsum dolor sit, amet consectetur adipisicing elit. Praesentium ipsam adipisci deserunt a dolore facere mollitia blanditiis, cum maxime modi saepe et animi reprehenderit, culpa odio molestias, voluptatibus ipsa harum quam? Harum aliquid repellat id quaerat sit quae earum ratione minus quidem beatae soluta dolorem pariatur non labore dolores saepe doloribus iure praesentium animi, odit quibusdam nihil numquam. Accusamus perspiciatis aut voluptas fugit quibusdam nisi repudiandae et enim temporibus? Ipsum quis, ipsa alias incidunt neque aut sit fugiat quod ex? Corrupti dignissimos minima non iure, repudiandae voluptas cupiditate reiciendis consectetur alias, unde ducimus. Tenetur, et eum. Aliquam porro error cumque.</p>
    </el-dialog>
  </div>
</template>

<script>

  export default {
    name: 'SignUpForm',

    data() {
      return {
        form: {
          name: '',
          email: '',
          password: ''
        },
        isFormVisible: true,
        errors: null,
        rules: {
          email: [
            { required: true, message: 'Пожалуйста, введите email', trigger: 'blur' },
            { type: 'email', message: 'Пожалуйста, введите правильный email', trigger: ['blur', 'change'] }
          ],
          password: [
            { required: true, message: 'Пожалуйста, введите пароль', trigger: 'blur' },
            { min: 5, message: 'Пароль должен содержать минимум 5 символов' }
          ]
        },
        agreementDialogVisible: false
      }
    },

    methods: {
      onRegister() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.$store.dispatch('register', {
              name: this.form.name,
              email: this.form.email,
              password: this.form.password
            })
              .then(() => {
                this.isFormVisible = false
                this.$notify({
                  title: 'Ваша заявка принята',
                  message: 'На указанный при регистрации email мы отправили инструкцию для доступа в ваш личный кабинет',
                  type: 'success'
                })
              })
          } else {
            console.error('Error: form validation')
            return false
          }
        })
      }
    }
  }
</script>
